import { Icon, Stack, Text, Tooltip } from "prism-react";

export const SettingItem: React.FC<{
  children: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  error?: string;
  warning?: string;
  message?: React.ReactNode;
  titleTooltip?: string;
}> = ({
  children,
  title,
  titleTooltip,
  description,
  error,
  warning,
  message,
}) => {
  return (
    <SettingItemWrapper gap={4} horizontal={false}>
      <Stack horizontal>
        <Stack css={{ flex: 1 }} gap={1}>
          <Stack css={{ svg: { display: "block" } }} horizontal>
            <Text color="neutral-fg-high">{title}</Text>

            {titleTooltip && (
              <Tooltip content={titleTooltip}>
                <div>
                  <Icon size={4} type="help" />
                </div>
              </Tooltip>
            )}
          </Stack>

          <Text color="neutral-fg-base">{description}</Text>
          {error ? <Text color="informative-error-base">{error}</Text> : null}
          {warning ? (
            <Text color="informative-warning-base">{warning}</Text>
          ) : null}
        </Stack>
        <Stack css={{ minWidth: 90, alignItems: "flex-end" }}>{children}</Stack>
      </Stack>
      {message}
    </SettingItemWrapper>
  );
};

export const SettingItemWrapper: React.FC<
  React.ComponentProps<typeof Stack>
> = (props) => {
  return (
    <Stack
      css={{
        justifyContent: "space-between",
        width: "100%",
        paddingBottom: "$6",

        "&:not(:last-child)": {
          borderBottom: "1px solid $neutral-bg-medium",
        },
      }}
      horizontal
      {...props}
    />
  );
};
